import React from 'react'

export const Consentimiento = () => {
	return (
		<div>Consentimiento</div>
	)
}
